import React, { useState } from "react";
import { Icon } from "../Icon";

export function IconBtn({
  icon,
  onClick,
  title,
  size = 32,
  badge = false,
  disabled = false,
  active = false,
  type = "button",
  style,
}) {
  const [hover, setHover] = useState(false);
  const isHover = hover && !disabled;
  return (
    <button
      type={type}
      onClick={onClick}
      title={title}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        position: "relative",
        width: size,
        height: size,
        borderRadius: 8,
        border: "none",
        background: active
          ? "var(--kr-action-soft-bg)"
          : isHover
            ? "var(--kr-bg-subtle)"
            : "transparent",
        color: active
          ? "var(--kr-action-soft-fg)"
          : isHover
            ? "var(--kr-fg-strong)"
            : "var(--kr-fg-muted)",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        transition:
          "background var(--kr-dur-fast) var(--kr-ease-out), color var(--kr-dur-fast) var(--kr-ease-out)",
        ...(style || {}),
      }}
    >
      <Icon name={icon} size={Math.round(size * 0.5)} />
      {typeof badge === "number" && badge > 0 ? (
        <span
          style={{
            position: "absolute",
            top: 2,
            right: 2,
            minWidth: 16,
            height: 16,
            padding: "0 4px",
            borderRadius: 999,
            background: "var(--kr-danger-600, #dc2626)",
            color: "#fff",
            fontSize: 10,
            fontWeight: 700,
            lineHeight: "16px",
            textAlign: "center",
            border: "1.5px solid var(--kr-bg-surface)",
            boxSizing: "content-box",
          }}
        >
          {badge > 99 ? "99+" : badge}
        </span>
      ) : badge ? (
        <span
          style={{
            position: "absolute",
            top: 6,
            right: 6,
            width: 7,
            height: 7,
            borderRadius: 999,
            background: "var(--kr-action)",
            border: "1.5px solid var(--kr-bg-surface)",
          }}
        />
      ) : null}
    </button>
  );
}

export default IconBtn;
